import React, { useState, useCallback } from 'react';
// import { Navigate } from 'react-router-dom';
// import earthiLogo from '../images/earthi-rev.png';
import { Col } from 'reactstrap';
// import { Tooltip } from 'react-tooltip';
// import useGainsQCApi from '../services/useGainsQCApi';
// import CapturesTable from '../components/tables/CapturesTable';
// import exportConfig from '../config';

const Testing = (props) => {
	const [count, setCount] = useState(0);

	// // Child renders every time Parent renders because handleClick is recreated.
	// const handleClick = () => {
	// 	console.log('Clicked');
	// };

	// // Child no longer re-renders unless handleClick actually changes.
	const handleClick = useCallback(() => {
		console.log('Clicked');
	  }, []); // no dependencies, so it never changes


	console.log(count)

	return (
		<>
			<Col className="px-0">
				<div className="contentContainer" id="dashboard-container">
					<div className="my-4">
						<hr></hr>

						<button onClick={() => setCount(count + 1)}>Increment Count</button>
						<Child onClick={handleClick} />
					</div>
				</div>
			</Col>
		</>
	);
};

export default Testing;


const Child = React.memo(({ onClick }) => {
	console.log('Child rendered');
	return <button onClick={onClick}>Child Button</button>;
  });